import { isFirebaseAuthError } from './firebase-auth-error';

/**
 * The Firestore SDK's own message is "Missing or insufficient permissions." or
 * "Failed to get document because the client is offline." — accurate, and the
 * wrong register for a screen. One sentence per code the services can actually
 * produce; anything else gets the caller's fallback, never the raw message.
 *
 * The guard is the same shape as the Auth one: any error carrying a string
 * `code` and a `message`, which is every FirebaseError regardless of product.
 */
const FIRESTORE_ERROR_MESSAGES: Record<string, string> = {
  'permission-denied': 'You do not have permission to do that.',
  unauthenticated: 'Your session has ended. Please sign in again.',
  unavailable: 'Could not reach the server. Check your connection and try again.',
  'deadline-exceeded': 'The request took too long. Please try again.',
  'not-found': 'That record no longer exists.',
  'already-exists': 'That record already exists.',
  'resource-exhausted': 'Too many requests. Please try again in a moment.',
  'failed-precondition': 'The request could not be completed in the current state.',
  aborted: 'The change clashed with another update. Please try again.',
};

/**
 * A sentence fit for the screen. A known Firestore/Storage code maps to its
 * wording; an unknown code, a plain Error or anything else yields `fallback`.
 */
export function describeFirestoreError(error: unknown, fallback: string): string {
  if (isFirebaseAuthError(error)) {
    return FIRESTORE_ERROR_MESSAGES[error.code] ?? fallback;
  }
  return fallback;
}
